import React from "react";
import Button from "../Helpers/Button/Button";
import trans, { isRTL } from "../../utils";
import { useNavigate } from "react-router-dom";

export default function FormBuilderHeader({
	addForm,
	submitAttempt,
	setActiveOption,
	setPreview,
	dataLength,
}) {
	const navigate = useNavigate();
	return (
		<>
			<div className="form-builder-header">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<div className="form-builder-header-title">
							{trans("create form template")}
						</div>
						<div className="form-builder-header-subtitle">
							{trans("Design custom forms for your workforce tasks")}
						</div>
					</div>
					<div
						className="form-preview-btn"
						style={{
							transform: isRTL ? "translateX(50%)" : "translateX(-50%)",
						}}
					>
						<Button
							img="/New/Randoms/eye.svg"
							imgspacing={false}
							text={trans("Preview")}
							type="default"
							onClick={() => setPreview(true)}
							disabled={dataLength === 0}
						/>
					</div>
					<div className="d-flex align-items-center">
						<Button
							text={trans("Cancel")}
							type="default"
							className="mx-2"
							onClick={() => navigate("/forms/all")}
						/>
						<Button
							text={trans("Save")}
							type="primary"
							htmlType="submit"
							onClick={() => setActiveOption("Main")}
						/>
					</div>
				</div>
				{submitAttempt && !addForm.isValid ? (
					<div
						style={{ transform: "translateY(-10px)" }}
						className={`validation ${isRTL ? "text-start" : "text-end"}`}
					>
						{trans("Please Check Required Inputs")}
					</div>
				) : (
					""
				)}
			</div>
		</>
	);
}
